import React, {useState} from 'react';

const AdminDashboards = () => {
  // Set Audit as the default dashboard
  const[activeDashboard, setActiveDashboard] = useState('netsmartz-audit-dashboard');
  const token = localStorage.getItem('token'); 

  if (!token) {
    return <div style={{ padding: '20px', color: 'red' }}>Error: No Authentication Token</div>;
  }

  const backendBase = "http://localhost:8000/osd/app/dashboards";
  // The iframe URL updates dynamically when a button is clicked
  const iframeSrc = `${backendBase}?token=${token}#/view/${activeDashboard}`;

  // Simple styles for the buttons
  const activeStyle = { background: '#2563eb', color: 'white', padding: '8px 16px', borderRadius: '4px', cursor: 'pointer', border: 'none' };
  const inactiveStyle = { background: '#475569', color: 'white', padding: '8px 16px', borderRadius: '4px', cursor: 'pointer', border: 'none' };

  return (
    <div style={{ width: '100%', height: '100vh', display: 'flex', flexDirection: 'column' }}>
      
      {/* 1. The Navigation Bar */}
      <div style={{ padding: '15px', background: '#1e293b', display: 'flex', gap: '15px' }}>
        <button 
          style={activeDashboard === 'netsmartz-audit-dashboard' ? activeStyle : inactiveStyle}
          onClick={() => setActiveDashboard('netsmartz-audit-dashboard')}
        >
          Audit Log
        </button>
        
        <button 
          style={activeDashboard === 'netsmartz-security-dashboard' ? activeStyle : inactiveStyle}
          onClick={() => setActiveDashboard('netsmartz-security-dashboard')}
        >
          Security
        </button>
        
        <button 
          style={activeDashboard === 'netsmartz-user-activity-dashboard' ? activeStyle : inactiveStyle}
          onClick={() => setActiveDashboard('netsmartz-user-activity-dashboard')}
        >
          User Activity
        </button>
      </div>

      {/* 2. The Dashboard Iframe */}
      <iframe
        src={iframeSrc}
        title="OpenSearch Dashboards"
        width="100%"
        style={{ flexGrow: 1, border: 'none' }} 
        sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-presentation allow-downloads"
        referrerPolicy="no-referrer-when-downgrade"
      />
      
    </div>
  );
};

export default AdminDashboards;

